<div class="container_dialog" data-testid="confirmation-dialog">
  <div class="header_popup">
    <div class="title_popup" data-testid="confirmation-dialog-title">
      {{ dialogData.title }}
    </div>
    <button data-testid="confirmation-dialog-close" (click)="this.dialogRef.close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div class="content_dialog">
    <div *ngIf="dialogData.icon" class="icon_dialog">
      <img class="icon_dialog_image" [src]="dialogData.icon" alt="" />
    </div>
    <div *ngIf="dialogData.body_title" class="body_title_dialog" [innerHTML]="dialogData.body_title"></div>
    <div class="text_dialog" data-testid="confirmation-dialog-text" [innerHTML]="dialogData.text">
    </div>
  </div>
  <div class="dialog-actions">
    <button
      *ngIf="dialogData.show_cancel"
      data-testid="confirmation-dialog-cancel"
      class="action-btn secondary-btn"
      (click)="this.dialogRef.close()"
    >
      <span>
        <mat-icon *ngIf="dialogData.cancel_icon">
          {{ dialogData.cancel_icon }}
        </mat-icon>
        {{ dialogData.cancel_text }}
      </span>
    </button>
    <button
      *ngIf="dialogData.show_third_btn"
      data-testid="confirmation-dialog-third"
      [class]="dialogData.third_btn_class"
      class="action-btn"
      (click)="thirdAction()"
    >
      <app-svg-icon *ngIf="dialogData.third_btn_icon" [svgIcon]="dialogData.third_btn_icon"></app-svg-icon>
      <span>{{ dialogData.third_btn_text }}</span>
    </button>
    <button
      data-testid="confirmation-dialog-confirm"
      [class]="dialogData.confirm_class"
      class="action-btn"
      (click)="closeTicket()"
    >
      <app-svg-icon *ngIf="dialogData.confirm_icon" [svgIcon]="dialogData.confirm_icon"></app-svg-icon>
      <span>{{ dialogData.confirm_text }}</span>
    </button>
  </div>
</div>
